'use client';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import StaffService from '@/app/services/staff';
import LoadingStaff from './components/LoadingStaff';


export default function Staff() {
    const t = useTranslations('About');

    const [data, setData] = useState<any[]>([])
    const [error, setError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    async function getStaff() {
        setIsLoading(true)
        try {
            const result: any = await StaffService.getList({ no_pagination: 1 });
            if (result?.data?.success) {
                setData(result?.data?.data.sort((a: any, b: any) => a.sort_order - b.sort_order))
                setError(false)
            }
        } catch (error: any) {
            setError(true)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => { getStaff() }, [])

    return (
        <>
            {isLoading ? (
                <LoadingStaff />
            ) : (
                <>
                    <div className='mb-10 px-4 md:px-20 text-start col-span-12 grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
                        {data?.map((user: any) => (
                            <div className='' key={user?.id}>
                                <Image
                                    src={user?.file?.url ?? "/images/about/nophoto.png"}
                                    width={300}
                                    height={300}
                                    alt={`${user?.first_name} ${user?.last_name}`}
                                    className="h-auto bw-image"
                                    style={{}}
                                />
                                <h2 className='text-md md:text-xl font-semibold mt-2'>
                                    {user?.first_name}{" "}{user?.last_name}
                                </h2>
                                <h2 className='text-sm md:text-md font-regular text-gray-400'>
                                    {user?.position}
                                </h2>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </>
    );
}
